import React, { useEffect, useMemo, useState } from 'react';
import { formatRelativeTime } from '../../utils/localOpsTime';
import JGLocalOpsMark from '../common/JGLocalOpsMark';

const getTickerSummaryText = (event, compact) => {
  const text = String(event?.summaryText || event?.label || event?.title || '').trim();
  if (!compact) return text;
  return text
    .replace(/^Local offer still available\s*[:\-]\s*/i, 'Still available - ')
    .replace(/^Available offer\s*[:\-]\s*/i, 'Available - ');
};

export default function LocalOpsFeedTicker({
  events = [],
  onOpen,
  autoRotateMs = 4200,
  compact = false,
}) {
  const [index, setIndex] = useState(0);
  const now = Date.now();

  const items = useMemo(() => events.slice(0, 3), [events]);
  const active = items[index % (items.length || 1)];
  const actor = active?.actor || null;
  const summaryText = getTickerSummaryText(active, compact);

  useEffect(() => {
    if (items.length <= 1) return undefined;
    const timer = setInterval(
      () => setIndex((prev) => (prev + 1) % items.length),
      autoRotateMs,
    );
    return () => clearInterval(timer);
  }, [items.length, autoRotateMs]);

  const summary = active ? (
    <>
      <span className="localops-feed-ticker__avatar">
        {actor?.profilePhoto ? (
          <img src={actor.profilePhoto} alt={actor.playerId || 'player'} />
        ) : (
          <span className="localops-feed-ticker__initial">
            {(actor?.playerId || '?').charAt(0).toUpperCase()}
          </span>
        )}
      </span>
      <span key={active.id} className="localops-feed-ticker__summary">
        {actor?.playerId && !compact
          ? `${actor.playerId} - ${summaryText}`
          : summaryText}
      </span>
      <span className="localops-feed-ticker__time">
        {formatRelativeTime(active.createdAt, now)}
      </span>
    </>
  ) : (
    <span className="localops-feed-ticker__summary">
      New activity will appear here.
    </span>
  );

  return (
    <div className="localops-feed-ticker-wrap">
      <button
        type="button"
        className="localops-feed-ticker"
        onClick={onOpen}
      >
        <span className="localops-feed-ticker__pulse" />
        <JGLocalOpsMark className="localops-feed-ticker__label" />
        {summary}
      </button>
    </div>
  );
}
